export class Center {
    id: number;
    code: string;
    name: string;
    status: string;
    regionId: number;
    regionName: string;
    createdBy: number;
    updatedBy: number;
}
